export default __webpack_public_path__ + "static/announce_w.752465f4a0cfb305985e23b527db9631.svg";